import { IStarBoxData } from '@leafer-ui/interface'
import { BoxData } from '@leafer-ui/draw'


export class StarBoxData extends BoxData implements IStarBoxData {

}
